// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:32:00.497Z
// Property: Quinn Residences at Edgewater Commons (ID: 6767906449167758)
// Collections: 1 floorplans (live), 44 POIs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167758",
  "property_external_id": null,
  "property_zillow_url": null,
  "property_apartments_url": null,
  "property_google_business_url": null,
  "property_linkedin_url": "https://www.linkedin.com/company/quinn-residences",
  "property_hubspot_id": "57147565640",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "quinn-residences-at-edgewater-commons",
  "property_name": "Quinn Residences at Edgewater Commons",
  "property_website_url": "https://live-quinn.com/property/edgewater-commons-raleigh-north-carolina/",
  "property_domain": null,
  "property_address": "3011 Sunrise Valley Pl",
  "property_full_address": "3011 Sunrise Valley Pl, Raleigh, NC 27610",
  "property_address_1": "3011 Sunrise Valley Pl",
  "property_address_2": null,
  "property_address_city": "Raleigh",
  "property_address_state": "NC",
  "property_address_zip_full": null,
  "property_address_zip": "27610",
  "property_address_country": "US",
  "property_address_county": "Wake County",
  "property_neighborhood_address": "Southeast Raleigh",
  "property_address_latitude": "35.793689",
  "property_address_longitude": "-78.543888",
  "property_email": "info@live-quinn.com",
  "property_phone": "866-784-6673",
  "property_call_tracking_phone": null,
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.live-quinn.com",
  "agency_contacts": null,
  "property_type": "Townhomes",
  "property_short_description": "Discover modern townhomes for rent at Quinn Residences at Edgewater Commons—minutes from Downtown Raleigh in a vibrant walkable community.",
  "property_long_description": "<p>Discover a new way to live at Quinn Residences at Edgewater Commons, a brand-new rental community in Raleigh, North Carolina. Perfectly located within a 55-acre mixed-use development, this vibrant neighborhood offers residents the ultimate in convenience, comfort, and connection.</p><p>Choose from spacious three- and four-bedroom townhomes for rent, thoughtfully designed with open-concept layouts, luxury finishes, and smart-home technology. Live within walking distance of ALDI, Food Lion, Ace Hardware, and more than 200,000 square feet of new shops, dining, and retail coming soon to Edgewater Commons.</p><p>Just 10 minutes from Downtown Raleigh, Quinn Residences at Edgewater Commons puts you close to everything you love—work, entertainment, restaurants, and green spaces—while offering a peaceful retreat to call home.</p>",
  "property_featured_image": null,
  "property_featured_image_media": null,
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "161",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": null,
  "property_primary_logo_media": null,
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#1f4f44",
  "property_secondary_color": "#e7bf9d",
  "property_font_color": "#303644",
  "property_color_4": null,
  "property_color_3": "#303644",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": null,
  "property_bedrooms_min": null,
  "property_bedrooms_max": null,
  "property_bathrooms_range": null,
  "property_bathrooms_min": null,
  "property_bathrooms_max": null,
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": "https://www.facebook.com/quinnresidences",
  "property_instagram_url": "https://www.instagram.com/quinnresidences/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJgwrrBIddrIkRO59q68mHLtE",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Quinn Residences at Edgewater Commons",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Home",
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": null,
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": null,
  "property_accessibility_blurb": null,
  "property_amenities_blurb": null,
  "property_applynow_blurb": null,
  "property_contactus_blurb": null,
  "property_faqs_blurb": null,
  "property_floorplans_blurb": null,
  "property_gallery_blurb": null,
  "property_interactivemap_blurb": null,
  "property_pets_blurb": null,
  "property_referafriend_blurb": null,
  "property_residentaccess_blurb": null,
  "property_reviews_blurb": null,
  "property_created_at": "1788979776805",
  "property_scheduletour_blurb": null,
  "property_thankyou_blurb": null,
  "property_virtualtours_blurb": null,
  "property_copyright": null,
  "property_seo_title_home": null,
  "property_seo_description_home": null,
  "property_seo_title_floorplans": "Floor Plans | Raleigh, NC Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal four-bedroom floor plan at Quinn Residences in Raleigh, NC. Browse our unique options and imagine your new home today!",
  "property_seo_title_amenities": null,
  "property_seo_description_amenities": null,
  "property_seo_title_gallery": null,
  "property_seo_description_gallery": null,
  "property_seo_title_virtualtours": "Virtual Tours | Quinn Residences at Edgewater Commons Apartments",
  "property_seo_description_virtualtours": "Step inside Quinn Residences at Edgewater Commons in Raleigh, NC. Enjoy spacious four-bedroom floor plans and take a virtual tour of your future home!",
  "property_seo_title_interactivemap": null,
  "property_seo_description_interactivemap": null,
  "property_seo_title_neighborhood": null,
  "property_seo_description_neighborhood": "Discover the vibrant lifestyle at Quinn Residences in Raleigh, NC—local favorites and hotspots await your new adventure!",
  "property_seo_title_contact": null,
  "property_seo_description_contact": "Connect with Quinn Residences at Edgewater Commons in Raleigh, NC. Our four-bedroom floor plans await! Have questions? Reach out to our leasing team today!",
  "property_seo_title_faqs": null,
  "property_seo_description_faqs": null,
  "property_seo_title_reviews": null,
  "property_seo_description_reviews": null,
  "property_seo_title_applynow": null,
  "property_seo_description_applynow": null,
  "property_seo_title_residentaccess": null,
  "property_seo_description_residentaccess": null,
  "property_seo_title_referafriend": null,
  "property_seo_description_referafriend": null,
  "property_seo_title_scheduletour": null,
  "property_seo_description_scheduletour": null,
  "property_seo_title_privacy": null,
  "property_seo_description_privacy": null,
  "property_seo_title_accessibility": null,
  "property_seo_description_accessibility": null,
  "property_seo_title_sitemap": null,
  "property_seo_description_sitemap": null,
  "property_seo_title_thankyou": null,
  "property_seo_description_thankyou": null,
  "property_seo_title_pets": "Pet Policy | Apartments in Raleigh, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793289637655",
  "amenities": [],
  "photo_gallery": [],
  "neighborhood_pois": [
    {
      "id": "custom_08fe741a-5d40-4ec3-9e9d-a2b7d7ecfc06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Sopranos Grill",
      "poi_type": "Restaurants",
      "poi_address": "1030 N Rogers Ln Ste 101, Raleigh, NC 27610, USA",
      "poi_short_description": "Comfy storefront spot for Italian classics from pizza to veal, offered with a wine list & coffee.",
      "poi_long_description": "Comfy storefront spot for Italian classics from pizza to veal, offered with a wine list & coffee.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-24c4-71fd-adf9-797a874383b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-24c4-71fd-adf9-797a874383b6",
        "storage_key": "property/6767906449167758/01a08783-24c4-71fd-adf9-797a874383b6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sopranosgrillnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8887467840527330240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sopranos-grill",
      "poi_latitude": "35.792148",
      "poi_longitude": "-78.549128",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 984-242-0883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c2f-77f0-804e-fac15d314c58",
        "storage_key": "property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-pw_A1crIkRwOtWw-mgVns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_f5710fe9-d2d1-4bc2-8354-78dce9104c37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Wang's Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1030 N Rogers Ln, Raleigh, NC 27610, USA",
      "poi_short_description": "Casual Chinese restaurant dishing up lunch and dinner options such as General Tso's chicken.",
      "poi_long_description": "Casual Chinese restaurant dishing up lunch and dinner options such as General Tso's chicken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-24dc-74ae-a73d-e49af4039895.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-24dc-74ae-a73d-e49af4039895",
        "storage_key": "property/6767906449167758/01a08783-24dc-74ae-a73d-e49af4039895.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15498409717774586896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wangs-kitchen",
      "poi_latitude": "35.7919426",
      "poi_longitude": "-78.54910939999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 919-792-0788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c2f-77f0-804e-fac15d314c58",
        "storage_key": "property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9967w1crIkREJRqM4ZpFdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_f5e9ef1e-e0ca-418c-a832-e27d7d0bd75c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Overtime Sports Pub",
      "poi_type": "Restaurants",
      "poi_address": "1030 N Rogers Ln #149, Raleigh, NC 27610, USA",
      "poi_short_description": "Boisterous spot featuring hearty pub grub & draft beer, plus flatscreen TVs & live entertainment.",
      "poi_long_description": "Boisterous spot featuring hearty pub grub & draft beer, plus flatscreen TVs & live entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-24ca-7728-8d4e-1409ce0b01e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-24ca-7728-8d4e-1409ce0b01e7",
        "storage_key": "property/6767906449167758/01a08783-24ca-7728-8d4e-1409ce0b01e7.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.overtimesportspub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6393105202531099279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overtime-sports-pub",
      "poi_latitude": "35.7911177",
      "poi_longitude": "-78.54769859999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 919-255-9556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c2f-77f0-804e-fac15d314c58",
        "storage_key": "property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9967w1crIkRj2KRQE_fuFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f091cc3c-7588-4856-b5fa-98483dfb5359",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Big Cheese Pizza Raleigh",
      "poi_type": "Restaurants",
      "poi_address": "1030 N Rogers Ln, Raleigh, NC 27610, USA",
      "poi_short_description": "Simple pizza chain with both ready-to-eat & made-to-order pies, plus breadsticks & chicken wings.",
      "poi_long_description": "Simple pizza chain with both ready-to-eat & made-to-order pies, plus breadsticks & chicken wings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-2d13-72c9-956f-cca86a659647.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-2d13-72c9-956f-cca86a659647",
        "storage_key": "property/6767906449167758/01a08783-2d13-72c9-956f-cca86a659647.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.bigcheese.pizza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7059829755512250080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-cheese-pizza-raleigh",
      "poi_latitude": "35.7916099",
      "poi_longitude": "-78.5486579",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-792-2245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c2f-77f0-804e-fac15d314c58",
        "storage_key": "property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9967w1crIkR4F4KEMKN-WE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_15317ed1-cae6-4fb8-b94f-18338677d780",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "El Tapatío Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4511 New Bern Ave, Raleigh, NC 27610, USA",
      "poi_short_description": "Casual joint offering familiar Mexican dishes such as fajitas & chimichangas in a colorful setting.",
      "poi_long_description": "Casual joint offering familiar Mexican dishes such as fajitas & chimichangas in a colorful setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-24c9-724b-987d-154af4fd1ce7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-24c9-724b-987d-154af4fd1ce7",
        "storage_key": "property/6767906449167758/01a08783-24c9-724b-987d-154af4fd1ce7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://eltapationewbern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3202689326642404277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-tapato-mexican-restaurant",
      "poi_latitude": "35.7987889",
      "poi_longitude": "-78.5592942",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-255-9161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c2f-77f0-804e-fac15d314c58",
        "storage_key": "property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrU1nAgdcrIkRtZt0WPk8ciw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_44eae343-f6fc-4873-b036-bc909168dda5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Chuan Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2004 New Bern Ave, Raleigh, NC 27610, USA",
      "poi_short_description": "Casual eatery in a shopping center serving Chinese dishes with a special focus on Sichuan cuisine.",
      "poi_long_description": "Casual eatery in a shopping center serving Chinese dishes with a special focus on Sichuan cuisine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-27a1-71fd-9d3d-a1f293d27fce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-27a1-71fd-9d3d-a1f293d27fce",
        "storage_key": "property/6767906449167758/01a08783-27a1-71fd-9d3d-a1f293d27fce.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.chuanxiacafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=969098661973172312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chuan-cafe",
      "poi_latitude": "35.7790711",
      "poi_longitude": "-78.6071509",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 919-594-1772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c2f-77f0-804e-fac15d314c58",
        "storage_key": "property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ7s8u_xfrIkRWKA3Oxnucg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1c10b821-e6e8-44f4-831d-bb6da4c0911e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Frank's Pizza & Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2030 New Bern Ave, Raleigh, NC 27610, USA",
      "poi_short_description": "Small pizzeria tucked in a strip mall serving creative pies, sandwiches & Italian specialty dishes.",
      "poi_long_description": "Small pizzeria tucked in a strip mall serving creative pies, sandwiches & Italian specialty dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-2732-7619-afcb-0bd5c64fb4c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-2732-7619-afcb-0bd5c64fb4c6",
        "storage_key": "property/6767906449167758/01a08783-2732-7619-afcb-0bd5c64fb4c6.webp",
        "width": 1280,
        "height": 1251
      },
      "poi_business_url": "https://frankspizzainraleigh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13788986085231463895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "franks-pizza--italian-restaurant",
      "poi_latitude": "35.7787986",
      "poi_longitude": "-78.60703769999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 919-231-8990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c2f-77f0-804e-fac15d314c58",
        "storage_key": "property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ889QxeNerIkR140Gj8lRXL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_8b40ba30-abac-4ab4-9346-291da9edadd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4411 New Bern Ave, Raleigh, NC 27610, USA",
      "poi_short_description": "Fast food restaurant known for its chicken sandwiches, nuggets, and waffle fries, plus breakfast and a kids' menu.",
      "poi_long_description": "Fast food restaurant known for its chicken sandwiches, nuggets, and waffle fries, plus breakfast and a kids' menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-279f-77fa-838a-56829b513f65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-279f-77fa-838a-56829b513f65",
        "storage_key": "property/6767906449167758/01a08783-279f-77fa-838a-56829b513f65.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/nc/new-bern-ave?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17338570950067413267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.798839",
      "poi_longitude": "-78.56131599999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 984-255-6784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c2f-77f0-804e-fac15d314c58",
        "storage_key": "property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6XKEhNpdrIkRE-GsV2r6nvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b691b252-ebb0-4ef3-98aa-a045bf867272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "4421 New Bern Avenue New Bern Commons, Raleigh, NC 27610, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-2407-7538-b9f2-71266f4b525f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-2407-7538-b9f2-71266f4b525f",
        "storage_key": "property/6767906449167758/01a08783-2407-7538-b9f2-71266f4b525f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/8487/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12903538525576861916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "35.79874",
      "poi_longitude": "-78.56078",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-231-3271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-6f8d-77a8-ace2-05765692ff59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08783-6f8d-77a8-ace2-05765692ff59",
        "storage_key": "property/6767906449167758/01a08783-6f8d-77a8-ace2-05765692ff59.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ2xLhdZFYrIkR3JiTUuyTErM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_7a2578d7-f364-432b-95b7-bc8c563a07f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Dairy Queen Grill & Chill",
      "poi_type": "Restaurants",
      "poi_address": "5260 New Bern Ave, Raleigh, NC 27610, USA",
      "poi_short_description": "Soft-serve ice cream & signature shakes top the menu at this classic burger & fries fast-food chain.",
      "poi_long_description": "Soft-serve ice cream & signature shakes top the menu at this classic burger & fries fast-food chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-2f97-758f-8ce2-e9a327610474.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-2f97-758f-8ce2-e9a327610474",
        "storage_key": "property/6767906449167758/01a08783-2f97-758f-8ce2-e9a327610474.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.triangledq.com/?y_source=1_ODk5NTk0NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7717292901220347430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dairy-queen-grill--chill",
      "poi_latitude": "35.7926176",
      "poi_longitude": "-78.54732340000001",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-792-0127",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c2f-77f0-804e-fac15d314c58",
        "storage_key": "property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM7fttQ1crIkRJu7hdAFVGWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_fc1a94b8-2ace-4154-9778-0b887caf09fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Irregardless",
      "poi_type": "Restaurants",
      "poi_address": "901 W Morgan St, Raleigh, NC 27603, USA",
      "poi_short_description": "Long-running cafe offering a global menu of locally sourced fare, plus live music.",
      "poi_long_description": "Long-running cafe offering a global menu of locally sourced fare, plus live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-2f92-7144-8f69-f9289484c7b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-2f92-7144-8f69-f9289484c7b0",
        "storage_key": "property/6767906449167758/01a08783-2f92-7144-8f69-f9289484c7b0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.irregardless.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17871882825529187038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "irregardless",
      "poi_latitude": "35.7811627",
      "poi_longitude": "-78.65594329999999",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 919-833-8898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c2f-77f0-804e-fac15d314c58",
        "storage_key": "property/6767906449167758/01a08781-4c2f-77f0-804e-fac15d314c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAzfRkGJfrIkR3loSk72uBfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_516a05bb-616a-4500-9234-d5bae7a4f282",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2900 Sunrise Valley Pl, Raleigh, NC 27610, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-30dd-7064-ab77-0084cc491ff2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-30dd-7064-ab77-0084cc491ff2",
        "storage_key": "property/6767906449167758/01a08783-30dd-7064-ab77-0084cc491ff2.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://info.aldi.us/stores/l/nc/raleigh/2900-sunrise-valley-place/f894",
      "poi_directions_map_url": "https://maps.google.com/?cid=6511295823568016229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.7938709",
      "poi_longitude": "-78.5471836",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c5b-738e-af32-dd0cb0359d7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c5b-738e-af32-dd0cb0359d7d",
        "storage_key": "property/6767906449167758/01a08781-4c5b-738e-af32-dd0cb0359d7d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75fzRQxcrIkRZZNBnw3FXFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_d852397c-87ff-45ae-96b7-b0053e4dc073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "1030 N Rogers Ln Ste 125, Raleigh, NC 27610, USA",
      "poi_short_description": "Chain grocery store offering bulk and organic products, plus prepared foods.",
      "poi_long_description": "Chain grocery store offering bulk and organic products, plus prepared foods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-31d4-762e-9f2e-ccbb48cec7e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-31d4-762e-9f2e-ccbb48cec7e9",
        "storage_key": "property/6767906449167758/01a08783-31d4-762e-9f2e-ccbb48cec7e9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.foodlion.com/nc/raleigh/1030-n-rogers-ln?y_source=1_NTA0NjAzOS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2760161054995715802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "35.791282",
      "poi_longitude": "-78.54866539999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 919-792-0321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c5b-738e-af32-dd0cb0359d7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c5b-738e-af32-dd0cb0359d7d",
        "storage_key": "property/6767906449167758/01a08781-4c5b-738e-af32-dd0cb0359d7d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvT6rOhJcrIkR2hbjBdsPTiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_821f9333-d34b-4930-b509-675ef989f970",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Carlie C's IGA",
      "poi_type": "Shopping & Retail",
      "poi_address": "4111 New Bern Ave, Raleigh, NC 27610, USA",
      "poi_short_description": "Grocery chain offering prepared foods, fresh produce, baked goods and deli items, along with meat and seafood departments.",
      "poi_long_description": "Grocery chain offering prepared foods, fresh produce, baked goods and deli items, along with meat and seafood departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-31b5-73f2-868a-6aa13a641e8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-31b5-73f2-868a-6aa13a641e8a",
        "storage_key": "property/6767906449167758/01a08783-31b5-73f2-868a-6aa13a641e8a.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://www.carliecs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10420014560534568585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carlie-cs-iga",
      "poi_latitude": "35.8003836",
      "poi_longitude": "-78.566622",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-250-7876",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c5b-738e-af32-dd0cb0359d7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c5b-738e-af32-dd0cb0359d7d",
        "storage_key": "property/6767906449167758/01a08781-4c5b-738e-af32-dd0cb0359d7d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8XR3c6perIkRiZ4PAwlUm5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6df9de26-1fc9-4c4c-a622-cb524b24e305",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4431 New Bern Ave, Raleigh, NC 27610, USA",
      "poi_short_description": "Chain store selling electronics, groceries, home goods, clothing and toys, much of it at budget prices.",
      "poi_long_description": "Chain store selling electronics, groceries, home goods, clothing and toys, much of it at budget prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-33d2-73da-8f3b-4b1bfd0a7a2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-33d2-73da-8f3b-4b1bfd0a7a2d",
        "storage_key": "property/6767906449167758/01a08783-33d2-73da-8f3b-4b1bfd0a7a2d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5292-raleigh-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15622576517856005807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.8009233",
      "poi_longitude": "-78.5600355",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-212-6442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c5c-7400-b159-f5ca3ce61bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c5c-7400-b159-f5ca3ce61bda",
        "storage_key": "property/6767906449167758/01a08781-4c5c-7400-b159-f5ca3ce61bda.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg-t7LgdcrIkRr44qL5KKztg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a864ac21-10bf-4a1e-92a7-cafd8a47a981",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4309 New Bern Ave NWC, Raleigh, NC 27610, USA",
      "poi_short_description": "Drugstore chain with a pharmacy, health and beauty items and everyday essentials.",
      "poi_long_description": "Drugstore chain with a pharmacy, health and beauty items and everyday essentials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-371c-75da-b9d8-2666c41fcdc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-371c-75da-b9d8-2666c41fcdc4",
        "storage_key": "property/6767906449167758/01a08783-371c-75da-b9d8-2666c41fcdc4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/raleigh-nc-pharmacies/4309-new-bern-ave-nwc-raleigh-nc-27610/storeid=7513?WT.mc_id=LS_GOOGLE_RX_7513",
      "poi_directions_map_url": "https://maps.google.com/?cid=4410971328180790065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.799299",
      "poi_longitude": "-78.5633424",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-231-2858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-6f80-7511-9896-6b665c8f3e14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08783-6f80-7511-9896-6b665c8f3e14",
        "storage_key": "property/6767906449167758/01a08783-6f80-7511-9896-6b665c8f3e14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP2EnH0BdrIkRMSOmeg3rNj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_02e0f366-173b-476b-84df-730660a4789a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4408 New Bern Ave Walgreens, Raleigh, NC 27610, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-37ab-70ad-9eb3-a58c0ace4cc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-37ab-70ad-9eb3-a58c0ace4cc5",
        "storage_key": "property/6767906449167758/01a08783-37ab-70ad-9eb3-a58c0ace4cc5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4408+new+bern+ave-raleigh-nc-27610/id=7549",
      "poi_directions_map_url": "https://maps.google.com/?cid=6287244787489440864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.7978467",
      "poi_longitude": "-78.5621877",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-231-6419",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-9e151cd08a8d",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ6WRZgFcrIkRYAQ8rtLHQFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_82b862eb-3698-4b85-ad41-086d1a8530e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Westlake Ace Hardware",
      "poi_type": "Shopping & Retail",
      "poi_address": "1080 N Rogers Ln, Raleigh, NC 27610, USA",
      "poi_short_description": "Locally owned hardware store part of a global chain for tools, paint, and home improvement supplies.",
      "poi_long_description": "Locally owned hardware store part of a global chain for tools, paint, and home improvement supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-3557-763f-a503-d15204ce7394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-3557-763f-a503-d15204ce7394",
        "storage_key": "property/6767906449167758/01a08783-3557-763f-a503-d15204ce7394.webp",
        "width": 1011,
        "height": 1280
      },
      "poi_business_url": "http://www.acehardware.com/store-details/18390?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=18390",
      "poi_directions_map_url": "https://maps.google.com/?cid=17519442725646709153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westlake-ace-hardware",
      "poi_latitude": "35.7927129",
      "poi_longitude": "-78.54896099999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 984-238-2277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c5c-7400-b159-f5ca3ce61bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c5c-7400-b159-f5ca3ce61bda",
        "storage_key": "property/6767906449167758/01a08781-4c5c-7400-b159-f5ca3ce61bda.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV3PfuOBdrIkRoTH5RFaQIfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_fb46f3b2-4738-4bbe-80d6-3c57a732f8d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Powell Center for Play and Ingenuity Magnet Elementary School",
      "poi_type": "Education",
      "poi_address": "1130 Marlborough Rd, Raleigh, NC 27610, USA",
      "poi_short_description": "Public magnet elementary school, Wake County Public School System.",
      "poi_long_description": "Public magnet elementary school, Wake County Public School System.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-3eb1-73b6-b4b5-5401ce0e9442.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-3eb1-73b6-b4b5-5401ce0e9442",
        "storage_key": "property/6767906449167758/01a08783-3eb1-73b6-b4b5-5401ce0e9442.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wcpss.net/powelles",
      "poi_directions_map_url": "https://maps.google.com/?cid=6778293331680219364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "powell-center-for-play-and-ingenuity-magnet-elementary-school",
      "poi_latitude": "35.7953523",
      "poi_longitude": "-78.6032359",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 919-856-7737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c5c-7400-b159-f1b4a95c29dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c5c-7400-b159-f1b4a95c29dd",
        "storage_key": "property/6767906449167758/01a08781-4c5c-7400-b159-f1b4a95c29dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzZQVftperIkR5NAySt9VEV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5fdd6241-b823-4baf-a925-13edb99ab0cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "River Oaks Middle School",
      "poi_type": "Education",
      "poi_address": "4700 New Bern Ave, Raleigh, NC 27610, USA",
      "poi_short_description": "Public middle school, Wake County Public School System.",
      "poi_long_description": "Public middle school, Wake County Public School System.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wcpss.net/riveroaksms",
      "poi_directions_map_url": "https://maps.google.com/?cid=11254917011563967714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-oaks-middle-school",
      "poi_latitude": "35.7974462",
      "poi_longitude": "-78.5583357",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-231-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c5c-7400-b159-f1b4a95c29dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c5c-7400-b159-f1b4a95c29dd",
        "storage_key": "property/6767906449167758/01a08781-4c5c-7400-b159-f1b4a95c29dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSz0wmwZcrIkR4nTFEmR_MZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5e4e89cd-564f-41ea-ae5c-644c8e67efd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Southeast Raleigh Magnet High School",
      "poi_type": "Education",
      "poi_address": "2600 Rock Quarry Rd, Raleigh, NC 27610, USA",
      "poi_short_description": "Public magnet high school, Wake County Public School System.",
      "poi_long_description": "Public magnet high school, Wake County Public School System.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-3cff-75bc-bfa6-461645b74af6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-3cff-75bc-bfa6-461645b74af6",
        "storage_key": "property/6767906449167758/01a08783-3cff-75bc-bfa6-461645b74af6.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://southeastraleighhs.wcpss.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2979027349650529885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southeast-raleigh-magnet-high-school",
      "poi_latitude": "35.7454267",
      "poi_longitude": "-78.6041578",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 919-856-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c5c-7400-b159-f1b4a95c29dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c5c-7400-b159-f1b4a95c29dd",
        "storage_key": "property/6767906449167758/01a08781-4c5c-7400-b159-f1b4a95c29dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL7c6DElerIkRXd4XSJehVyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_10998e4d-9c0b-4cd7-a4dd-d1dc97610413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Wake Tech Perry Health Sciences Campus",
      "poi_type": "Education",
      "poi_address": "2901 Holston Ln, Raleigh, NC 27610, USA",
      "poi_short_description": "Wake Technical Community College's health sciences campus, near WakeMed Raleigh Campus.",
      "poi_long_description": "Wake Technical Community College's health sciences campus, near WakeMed Raleigh Campus.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-2262-73ba-a88e-2eb8fae57dd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08781-2262-73ba-a88e-2eb8fae57dd8",
        "storage_key": "property/6767906449167758/01a08781-2262-73ba-a88e-2eb8fae57dd8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.waketech.edu/about-wake-tech/campuses-centers/health-sciences-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=17090137081513653886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wake-tech-perry-health-sciences-campus",
      "poi_latitude": "35.7850283",
      "poi_longitude": "-78.5845235",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-747-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c5c-7400-b159-f1b4a95c29dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c5c-7400-b159-f1b4a95c29dd",
        "storage_key": "property/6767906449167758/01a08781-4c5c-7400-b159-f1b4a95c29dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_ZSZP75erIkRfjZa0iBdLO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fffce896-33ce-4774-9ede-7df3ce9b4323",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Kelley Austin KinderCare",
      "poi_type": "Education",
      "poi_address": "3103 Kelley Austin Dr, Raleigh, NC 27610, USA",
      "poi_short_description": "KinderCare child care and early-education center.",
      "poi_long_description": "KinderCare child care and early-education center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-3fa4-717b-b7c8-d7610daa72e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-3fa4-717b-b7c8-d7610daa72e3",
        "storage_key": "property/6767906449167758/01a08783-3fa4-717b-b7c8-d7610daa72e3.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/raleigh/nc/086149?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_MTQ1MDczMzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2312613248080783025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kelley-austin-kindercare",
      "poi_latitude": "35.7923822",
      "poi_longitude": "-78.58365599999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-231-1936",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c5c-7400-b159-f1b4a95c29dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c5c-7400-b159-f1b4a95c29dd",
        "storage_key": "property/6767906449167758/01a08781-4c5c-7400-b159-f1b4a95c29dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMazFXJZerIkRsaa3En8NGCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_20792984-dd19-46be-8b8a-14461dab5173",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Coastal Credit Union Music Park at Walnut Creek",
      "poi_type": "Entertainment",
      "poi_address": "3801 Rock Quarry Rd, Raleigh, NC 27610, USA",
      "poi_short_description": "This sizable outdoor music venue showcasing concerts by major bands & artists also hosts festivals.",
      "poi_long_description": "This sizable outdoor music venue showcasing concerts by major bands & artists also hosts festivals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-4134-72b8-9088-f4da81f7f760.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-4134-72b8-9088-f4da81f7f760",
        "storage_key": "property/6767906449167758/01a08783-4134-72b8-9088-f4da81f7f760.webp",
        "width": 1280,
        "height": 687
      },
      "poi_business_url": "https://www.coastalcreditunionmusicpark.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=10804940355837784305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coastal-credit-union-music-park-at-walnut-creek",
      "poi_latitude": "35.7509181",
      "poi_longitude": "-78.5779143",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 919-831-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-9e151cd08a8d",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH3eNBXBerIkR8XD-sAHc8pU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_ac5b873a-5b12-4a6b-8d15-ccbf6715198f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Marbles Kids Museum",
      "poi_type": "Entertainment",
      "poi_address": "201 E Hargett St, Raleigh, NC 27601, USA",
      "poi_short_description": "Children's museum featuring a wide variety of interactive displays for toddlers & school-age kids.",
      "poi_long_description": "Children's museum featuring a wide variety of interactive displays for toddlers & school-age kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-251d-713e-8ab4-f129096aa9fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08781-251d-713e-8ab4-f129096aa9fb",
        "storage_key": "property/6767906449167758/01a08781-251d-713e-8ab4-f129096aa9fb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.marbleskidsmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10113596087737764998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marbles-kids-museum",
      "poi_latitude": "35.7783093",
      "poi_longitude": "-78.6364427",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 919-834-4040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-a129d7e99e92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-a129d7e99e92",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-a129d7e99e92.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-TWbW1frIkRhsxjww62Wow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_58baafda-235d-41a6-b5d7-a9e5407570f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "North Carolina Museum of Natural Sciences",
      "poi_type": "Entertainment",
      "poi_address": "11 W Jones St, Raleigh, NC 27601, USA",
      "poi_short_description": "Exhibits on NC's geology, flora & fauna, plus fossil collections, 3D films & live-animal programs.",
      "poi_long_description": "Exhibits on NC's geology, flora & fauna, plus fossil collections, 3D films & live-animal programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-2234-73ad-b5aa-bd33d57e794a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08781-2234-73ad-b5aa-bd33d57e794a",
        "storage_key": "property/6767906449167758/01a08781-2234-73ad-b5aa-bd33d57e794a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://naturalsciences.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9871916602311768126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-carolina-museum-of-natural-sciences",
      "poi_latitude": "35.7821824",
      "poi_longitude": "-78.63929739999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 919-707-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-a129d7e99e92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-a129d7e99e92",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-a129d7e99e92.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_wdGWxfrIkRPvgSndgXAIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_dd4f30d8-6f51-4884-9335-30be55d16ecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Red Hat Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "500 South McDowell St, Raleigh, NC 27601, USA",
      "poi_short_description": "High-tech, 5,000-seat amphitheater hosting musical acts from all genres, with food & beverage stops.",
      "poi_long_description": "High-tech, 5,000-seat amphitheater hosting musical acts from all genres, with food & beverage stops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-44a8-7388-b098-c9fd6f81597a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-44a8-7388-b098-c9fd6f81597a",
        "storage_key": "property/6767906449167758/01a08783-44a8-7388-b098-c9fd6f81597a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.redhatamphitheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8838069225900336555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-hat-amphitheater",
      "poi_latitude": "35.7732062",
      "poi_longitude": "-78.6434503",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 919-996-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-9e151cd08a8d",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYvf23BfrIkRq-UZhiIhp3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_ce9ea3b5-8687-4052-a8df-681c03b46d2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Martin Marietta Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "2 E South St, Raleigh, NC 27601, USA",
      "poi_short_description": "Multiple venues for music, theater & other live performances, plus event spaces & an art gallery.",
      "poi_long_description": "Multiple venues for music, theater & other live performances, plus event spaces & an art gallery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-4353-719e-8b8e-4ca0d856a4e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-4353-719e-8b8e-4ca0d856a4e1",
        "storage_key": "property/6767906449167758/01a08783-4353-719e-8b8e-4ca0d856a4e1.webp",
        "width": 960,
        "height": 644
      },
      "poi_business_url": "http://www.martinmariettacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13462923112007999762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martin-marietta-center-for-the-performing-arts",
      "poi_latitude": "35.7712601",
      "poi_longitude": "-78.6396078",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 919-996-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-9e151cd08a8d",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY101yZBYrIkREiGioT3p1bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_a11028f7-f962-44f9-91fc-0c60fb118c90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "CAM Raleigh",
      "poi_type": "Entertainment",
      "poi_address": "409 W Martin St, Raleigh, NC 27603, USA",
      "poi_short_description": "Contemporary Art Museum is a modern space for art & design exhibits, film screenings & events.",
      "poi_long_description": "Contemporary Art Museum is a modern space for art & design exhibits, film screenings & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-44f1-752f-96a7-664c69d04ab0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-44f1-752f-96a7-664c69d04ab0",
        "storage_key": "property/6767906449167758/01a08783-44f1-752f-96a7-664c69d04ab0.webp",
        "width": 1023,
        "height": 1280
      },
      "poi_business_url": "http://camraleigh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9427635058729385219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cam-raleigh",
      "poi_latitude": "35.7768649",
      "poi_longitude": "-78.645663",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-a129d7e99e92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-a129d7e99e92",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-a129d7e99e92.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJNSN7nnpfrIkRA32V2yKw1YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_572346ec-f568-433b-b7b4-17d796813377",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Pullen Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "520 Ashe Ave, Raleigh, NC 27606, USA",
      "poi_short_description": "5th-oldest amusement park in the U.S., with a carousel, mini-train, paddle boats, playground & more.",
      "poi_long_description": "5th-oldest amusement park in the U.S., with a carousel, mini-train, paddle boats, playground & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-488c-722a-af26-62a8cf604fd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-488c-722a-af26-62a8cf604fd1",
        "storage_key": "property/6767906449167758/01a08783-488c-722a-af26-62a8cf604fd1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.raleighnc.gov/parks/content/ParksRec/Articles/Parks/Pullen.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13304147730283634675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pullen-park",
      "poi_latitude": "35.7792205",
      "poi_longitude": "-78.66287080000001",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 919-996-6468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-a5412594bf8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-a5412594bf8f",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-a5412594bf8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWMB44X1rIkR8x_gTt_Tobg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_38755a1c-44df-4011-93f7-ce7dc691290f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "WakeMed Raleigh Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "3000 New Bern Ave, Raleigh, NC 27610, USA",
      "poi_short_description": "WakeMed's flagship hospital and Level I trauma center on New Bern Avenue.",
      "poi_long_description": "WakeMed's flagship hospital and Level I trauma center on New Bern Avenue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-3192-7588-9fd3-b0638dd4157f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08781-3192-7588-9fd3-b0638dd4157f",
        "storage_key": "property/6767906449167758/01a08781-3192-7588-9fd3-b0638dd4157f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wakemed.org/location/wakemed-raleigh-campus?utm_source=google-gbp&utm_medium=organic&utm_campaign=WMHHR046",
      "poi_directions_map_url": "https://maps.google.com/?cid=8993548881962402941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wakemed-raleigh-campus",
      "poi_latitude": "35.78387",
      "poi_longitude": "-78.5881198",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 919-350-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c3c-72f1-8768-3801808daf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c3c-72f1-8768-3801808daf9a",
        "storage_key": "property/6767906449167758/01a08781-4c3c-72f1-8768-3801808daf9a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f8Pn79erIkRfQR76w6Bz3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_8111667a-ece1-44a7-9560-0fa027041c48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "NC FITNESS CLUB",
      "poi_type": "Health and Wellness",
      "poi_address": "3917 New Bern Ave, Raleigh, NC 27610, USA",
      "poi_short_description": "Gym and fitness club on New Bern Avenue.",
      "poi_long_description": "Gym and fitness club on New Bern Avenue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-4a3c-708b-93ff-bba7129aaa29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-4a3c-708b-93ff-bba7129aaa29",
        "storage_key": "property/6767906449167758/01a08783-4a3c-708b-93ff-bba7129aaa29.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://www.ncfitnessclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12642812753340758019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nc-fitness-club",
      "poi_latitude": "35.8007824",
      "poi_longitude": "-78.57076289999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-343-0976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-9e151cd08a8d",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgy60o6terIkRA3in9DZLdK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3b4c31df-24f3-4e12-ad8c-6bf433c8fb2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Southeast Raleigh YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "1436 Rock Quarry Rd, Raleigh, NC 27610, USA",
      "poi_short_description": "YMCA of the Triangle branch with fitness facilities and youth programs.",
      "poi_long_description": "YMCA of the Triangle branch with fitness facilities and youth programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-4a61-740e-88b0-de9a8059fbdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-4a61-740e-88b0-de9a8059fbdc",
        "storage_key": "property/6767906449167758/01a08783-4a61-740e-88b0-de9a8059fbdc.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://ymcatriangle.org/locations/southeast-raleigh-ymca?utm_source=google&utm_medium=organic&utm_campaign=gmb-location",
      "poi_directions_map_url": "https://maps.google.com/?cid=8397180245624628654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southeast-raleigh-ymca",
      "poi_latitude": "35.760784",
      "poi_longitude": "-78.6148303",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 919-359-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-9e151cd08a8d",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9TwwHG5frIkRriVid_HGiHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_9faaa128-562e-45c4-a2cc-f15d5fe96967",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Anderson Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "20 Anderson Point Dr, Raleigh, NC 27610, USA",
      "poi_short_description": "This park has wildlife habitat, a historic homestead, a stone amphitheater & canoe areas.",
      "poi_long_description": "This park has wildlife habitat, a historic homestead, a stone amphitheater & canoe areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-3913-7278-8c4f-d9a432457844.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08781-3913-7278-8c4f-d9a432457844",
        "storage_key": "property/6767906449167758/01a08781-3913-7278-8c4f-d9a432457844.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.raleighnc.gov/home/content/ParksRec/Articles/Parks/AndersonPoint.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5965735465814662180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anderson-point-park",
      "poi_latitude": "35.7725054",
      "poi_longitude": "-78.54283889999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-996-5994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-a5412594bf8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-a5412594bf8f",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-a5412594bf8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ciQtj5crIkRJBzVX8yMylI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e5154736-5f76-4f10-b644-978eea3fbaf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Neuse River Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Parking, lot 1721 Riverview Rd, Raleigh, NC 27610, USA",
      "poi_short_description": "Popular with runners & cyclists, this 27.5-mile long riverside trail traverses woodlands & wetlands.",
      "poi_long_description": "Popular with runners & cyclists, this 27.5-mile long riverside trail traverses woodlands & wetlands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-3925-746a-b76c-a5e1fa23c676.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08781-3925-746a-b76c-a5e1fa23c676",
        "storage_key": "property/6767906449167758/01a08781-3925-746a-b76c-a5e1fa23c676.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://raleighnc.gov/places/neuse-river-greenway-trail",
      "poi_directions_map_url": "https://maps.google.com/?cid=9204154695600324289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neuse-river-trail",
      "poi_latitude": "35.7548336",
      "poi_longitude": "-78.5335095",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 919-996-3285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-a5412594bf8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-a5412594bf8f",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-a5412594bf8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ9fC8rJdrIkRwT4AEe65u38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_79ba4273-fe0d-46bb-9e33-675b83840e6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Walnut Creek Wetland Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "950 Peterson St, Raleigh, NC 27610, USA",
      "poi_short_description": "Eco-friendly nature center offering classes, public programs, walking trails & wildlife observation.",
      "poi_long_description": "Eco-friendly nature center offering classes, public programs, walking trails & wildlife observation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-4f2a-7504-8f46-806aa3510809.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-4f2a-7504-8f46-806aa3510809",
        "storage_key": "property/6767906449167758/01a08783-4f2a-7504-8f46-806aa3510809.webp",
        "width": 1280,
        "height": 759
      },
      "poi_business_url": "https://raleighnc.gov/places/walnut-creek-wetland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9750598584824805656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walnut-creek-wetland-center",
      "poi_latitude": "35.7603769",
      "poi_longitude": "-78.6249486",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 919-996-2760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-a5412594bf8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-a5412594bf8f",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-a5412594bf8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVbIxeKZfrIkRGLnog8AVUYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6bb3bf04-0b66-4866-978d-1486962dafc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Worthdale Park Community Center",
      "poi_type": "Entertainment",
      "poi_address": "1001 Cooper Rd, Raleigh, NC 27610, USA",
      "poi_short_description": "Relaxed, well-kept park featuring softball fields, a playground and walking trails.",
      "poi_long_description": "Relaxed, well-kept park featuring softball fields, a playground and walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-5545-7248-9a68-5af885e82d87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-5545-7248-9a68-5af885e82d87",
        "storage_key": "property/6767906449167758/01a08783-5545-7248-9a68-5af885e82d87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://raleighnc.gov/parks-and-recreation/places/worthdale-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=20545260224849783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "worthdale-park-community-center",
      "poi_latitude": "35.7634082",
      "poi_longitude": "-78.5871453",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 919-996-2730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-9e151cd08a8d",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN2ntaYperIkRdyeFKc79SAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_b295a9e4-856e-4e23-ac57-08232afdcc9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "GoRaleigh",
      "poi_type": "Transportation & Transit",
      "poi_address": "4104 Poole Rd, Raleigh, NC 27610, USA",
      "poi_short_description": "The City of Raleigh's public bus system; administrative office.",
      "poi_long_description": "The City of Raleigh's public bus system; administrative office.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-534f-7709-8a4d-0e7f00862e91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-534f-7709-8a4d-0e7f00862e91",
        "storage_key": "property/6767906449167758/01a08783-534f-7709-8a4d-0e7f00862e91.webp",
        "width": 1280,
        "height": 420
      },
      "poi_business_url": "http://goraleigh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1009560678318233590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goraleigh",
      "poi_latitude": "35.7676187",
      "poi_longitude": "-78.56557289999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-485-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-6f81-77e2-82ba-4334b2a9448d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08783-6f81-77e2-82ba-4334b2a9448d",
        "storage_key": "property/6767906449167758/01a08783-6f81-77e2-82ba-4334b2a9448d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTZr-0ClcrIkR9ldcihauAg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_cb3371b9-9e76-4d9d-955d-9f1c261d8665",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Union Station Raleigh, NC",
      "poi_type": "Transportation & Transit",
      "poi_address": "510 W Martin St, Raleigh, NC 27601, USA",
      "poi_short_description": "Amtrak station in downtown Raleigh's Warehouse District.",
      "poi_long_description": "Amtrak station in downtown Raleigh's Warehouse District.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-54dd-774c-b810-fdd6f72ff6de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-54dd-774c-b810-fdd6f72ff6de",
        "storage_key": "property/6767906449167758/01a08783-54dd-774c-b810-fdd6f72ff6de.webp",
        "width": 1280,
        "height": 911
      },
      "poi_business_url": "https://raleighnc.gov/transportation/places/raleigh-union-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=7959250046478144011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-station-raleigh-nc",
      "poi_latitude": "35.7772597",
      "poi_longitude": "-78.6473649",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 864-266-1340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-9e151cd08a8d",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0zPbyD9frIkRC1LXUr_vdG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_a3979519-eb9f-4f44-af3d-64b30262bbb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Raleigh-Durham International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 John Brantley Blvd, Morrisville, NC 27560, USA",
      "poi_short_description": "Hub with domestic, London & Caribbean flights, plus a public observation area for plane-watching.",
      "poi_long_description": "Hub with domestic, London & Caribbean flights, plus a public observation area for plane-watching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-51b6-74ec-8290-0ee2e293aaf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-51b6-74ec-8290-0ee2e293aaf3",
        "storage_key": "property/6767906449167758/01a08783-51b6-74ec-8290-0ee2e293aaf3.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.rdu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16394108500305999341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raleigh-durham-international-airport",
      "poi_latitude": "35.8797678",
      "poi_longitude": "-78.7855512",
      "poi_miles_from_property": "25.0 mi",
      "poi_walking_minutes": "9 hours 15 mins",
      "poi_biking_minutes": "2 hours 13 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 919-840-2123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-50db-7605-8c0d-dfe5b5ef0be1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-50db-7605-8c0d-dfe5b5ef0be1",
        "storage_key": "property/6767906449167758/01a08781-50db-7605-8c0d-dfe5b5ef0be1.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJz3mOAvrwrIkR7XXzQdKSg-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_93e7343b-d772-41cf-817d-7097214e3f97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "GoRaleigh Station (city and regional transit bus)",
      "poi_type": "Transportation & Transit",
      "poi_address": "214 S Blount St, Raleigh, NC 27601, USA",
      "poi_short_description": "Downtown transit center for GoRaleigh and regional GoTriangle buses.",
      "poi_long_description": "Downtown transit center for GoRaleigh and regional GoTriangle buses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-59f9-70a1-92ad-328b7ef0f296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-59f9-70a1-92ad-328b7ef0f296",
        "storage_key": "property/6767906449167758/01a08783-59f9-70a1-92ad-328b7ef0f296.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11058758950602854308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goraleigh-station-city-and-regional-transit-bus",
      "poi_latitude": "35.777637",
      "poi_longitude": "-78.636878",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 919-833-7522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-6fc7-74f0-a54e-e90855472937.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08783-6fc7-74f0-a54e-e90855472937",
        "storage_key": "property/6767906449167758/01a08783-6fc7-74f0-a54e-e90855472937.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVVheXJfrIkRpM9ae6yaeJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_garage"
    },
    {
      "id": "custom_4c6c314e-8fbd-4248-a962-3eb62d6802d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Duke Raleigh Hospital, a Campus of Duke University Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3400 Wake Forest Rd, Raleigh, NC 27609, USA",
      "poi_short_description": "Duke Health community hospital on Wake Forest Road.",
      "poi_long_description": "Duke Health community hospital on Wake Forest Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-31ec-77f6-a43d-87b68b6432ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08781-31ec-77f6-a43d-87b68b6432ac",
        "storage_key": "property/6767906449167758/01a08781-31ec-77f6-a43d-87b68b6432ac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.dukehealth.org/hospitals/duke-raleigh-hospital/home?utm_source=google&utm_medium=local&utm_campaign=evergreen",
      "poi_directions_map_url": "https://maps.google.com/?cid=1486526422636663754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duke-raleigh-hospital-a-campus-of-duke-university-hospital",
      "poi_latitude": "35.8282966",
      "poi_longitude": "-78.618179",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 919-954-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c3c-72f1-8768-3801808daf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c3c-72f1-8768-3801808daf9a",
        "storage_key": "property/6767906449167758/01a08781-4c3c-72f1-8768-3801808daf9a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsfyN6d1YrIkRypN9yuczoRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_769402fe-648d-4957-b0e8-09f297800a0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "First Citizens Banc Shares Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4300 Six Forks Rd #4300, Raleigh, NC 27609, USA",
      "poi_short_description": "Headquarters of First Citizens Bank.",
      "poi_long_description": "Headquarters of First Citizens Bank.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-5d18-726d-ac15-6cdc4b66a013.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-5d18-726d-ac15-6cdc4b66a013",
        "storage_key": "property/6767906449167758/01a08783-5d18-726d-ac15-6cdc4b66a013.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.firstcitizens.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2927997753332946257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-citizens-banc-shares-inc",
      "poi_latitude": "35.8389016",
      "poi_longitude": "-78.6412234",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 919-716-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-6fca-719a-8fc4-7ca086212b4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08783-6fca-719a-8fc4-7ca086212b4f",
        "storage_key": "property/6767906449167758/01a08783-6fca-719a-8fc4-7ca086212b4f.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJ02atbZFYrIkRUVWNhnFWoig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "custom_7686d101-fc5a-4763-80e7-e772442bb8d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758",
      "source": "custom",
      "poi_name": "Red Hat",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 E Davie St, Raleigh, NC 27601, USA",
      "poi_short_description": "Red Hat's global headquarters (Red Hat Tower) in downtown Raleigh.",
      "poi_long_description": "Red Hat's global headquarters (Red Hat Tower) in downtown Raleigh.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08783-5f07-742e-bd3d-bf0a18b2c7e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a08783-5f07-742e-bd3d-bf0a18b2c7e2",
        "storage_key": "property/6767906449167758/01a08783-5f07-742e-bd3d-bf0a18b2c7e2.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.redhat.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4930590588322609574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-hat",
      "poi_latitude": "35.7754301",
      "poi_longitude": "-78.6377795",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 919-754-4950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a08781-4c30-7779-938a-9e151cd08a8d",
        "storage_key": "property/6767906449167758/01a08781-4c30-7779-938a-9e151cd08a8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwWHY-571rIkRpnnaRQT6bEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-9e29-717a-8108-158260aa97fc",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Quinn Residences at Edgewater Commons Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758"
    },
    {
      "lead_collector_id": "01a0abe0-9ea8-769f-868a-913be378f391",
      "lead_source": "LANDING_PAGE",
      "name": "Quinn Residences at Edgewater Commons Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167758"
    }
  ],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977272089"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KJ34R6MV"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57147565640"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977272089",
  "custom_google_gtm_id": "GTM-KJ34R6MV",
  "custom_rollout_phase": "Phase 2",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57147565640",
  "custom_social_subscription": "none",
  "custom_website_subscription": "custom",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_audioeye_site_id": "e4beccea-8d13-4617-9e64-48f27a4d37d8",
  "custom_audioeye_site_hash": "c9957b2a77c20660ab3a455a62a97bae"
};

export const generatedAt = '2026-10-29T18:32:00.497Z';
